document.addEventListener("DOMContentLoaded", function () {
    const outerContainer = document.querySelector('.bwx-stack-outer');
    if (!outerContainer) return;

    const sectionId = outerContainer.getAttribute('data-section-id');
    const container = document.getElementById(`bwx-container-${sectionId}`);
    if (!container) return;

    let slides = Array.from(container.querySelectorAll('.bwx-stack-slide'));
    if (slides.length === 0) return;

    let isAnimating = false;
    let autoScrollTimer = null;
    
    const sectionConfig = (window.BwxStackConfig && window.BwxStackConfig[sectionId]) || { autoplay: true, autoplaySpeed: 5000 };
    const scrollInterval = sectionConfig.autoplaySpeed;

    const positions = ['position-0', 'position-1', 'position-2', 'position-3'];

    if (typeof gsap !== "undefined") {
        gsap.from(document.querySelector(`#bwx-stack-${sectionId} .bwx-stack-heading`), {
            opacity: 0,
            y: 60,
            duration: 1,
            ease: "power3.out"
        });

        gsap.to(container.querySelectorAll(".bwx-layer-one"), {
            y: -8,
            duration: 2.6,
            repeat: -1,
            yoyo: true,
            ease: "sine.inOut"
        });

        slides.forEach(slide => {
            const frontCard = slide.querySelector(".bwx-layer-one");
            if(!frontCard) return;

            frontCard.addEventListener("mousemove", function(e){
                const rect = frontCard.getBoundingClientRect();
                const x = (e.clientX - rect.left) / rect.width;
                const y = (e.clientY - rect.top) / rect.height;
                const rotateY = (x - .5) * 12;
                const rotateX = (.5 - y) * 10;
                gsap.to(frontCard, {
                    rotationY: rotateY,
                    rotationX: rotateX,
                    transformPerspective: 1000,
                    transformOrigin: "center",
                    duration: .4,
                    ease: "power2.out"
                });
            });

            frontCard.addEventListener("mouseleave", function(){
                gsap.to(frontCard, {
                    rotationX: 0,
                    rotationY: 0,
                    duration: .8,
                    ease: "power3.out"
                });
            });
        });
    }

    function handleCardCycle() {
        if (isAnimating || slides.length < 2) return;
        isAnimating = true;

        const topCard = slides[0];
        const randomDirectionClass = Math.random() > 0.5 ? 'spread-out-left' : 'spread-out-right';
        
        if (randomDirectionClass === 'spread-out-left') {
            outerContainer.classList.add('lanyard-sway-left');
        } else {
            outerContainer.classList.add('lanyard-sway-right');
        }

        topCard.classList.add(randomDirectionClass);

        setTimeout(() => {
            slides.push(slides.shift());

            slides.forEach((slide, index) => {
                positions.forEach(p => slide.classList.remove(p));
                const targetPos = index < positions.length ? positions[index] : positions[positions.length - 1];
                slide.classList.add(targetPos);
            });

            topCard.classList.remove(randomDirectionClass);
            outerContainer.classList.remove('lanyard-sway-left', 'lanyard-sway-right');
            
            setTimeout(() => { isAnimating = false; }, 50);
        }, 350);
    }

    function startAutoScroll() {
        if (sectionConfig.autoplay) {
            autoScrollTimer = setInterval(handleCardCycle, scrollInterval);
        }
    }

    function stopAutoScroll() {
        if (autoScrollTimer) clearInterval(autoScrollTimer);
    }

    container.addEventListener('click', function(e) {
        if(e.target.closest('.bwx-linkedin-btn') || e.target.closest('.bwx-menu-btn')) return;
        stopAutoScroll();
        handleCardCycle();
        startAutoScroll();
    });

    outerContainer.addEventListener('mouseenter', stopAutoScroll);
    outerContainer.addEventListener('mouseleave', startAutoScroll);

    document.addEventListener("keydown", function(e) {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            stopAutoScroll();
            handleCardCycle();
            startAutoScroll();
        }
    });

    let touchStartX = 0;
    let touchEndX = 0;
    outerContainer.addEventListener("touchstart", function(e) {
        touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });

    outerContainer.addEventListener("touchend", function(e) {
        touchEndX = e.changedTouches[0].clientX;
        if (Math.abs(touchStartX - touchEndX) < 50) return;
        
        stopAutoScroll();
        handleCardCycle();
        startAutoScroll();
    }, { passive: true });

    startAutoScroll();
});